/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-11-02 14:20:14
 * @LastEditors: jyf
 * @LastEditTime: 2022-11-18 09:52:15
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Carrier {
    /**
    * 列表
    */
    export var GetList = (query: type.GetCarrierListPayload): Promise<any> => {
        return Get(`/msls/Carrier/GetCarrierList?${qs.stringify(query)}`, {});
    };
    /**
    * 新增
    */
    export var Add = (body: type.AddCarrierVM): Promise<any> => {
        return Post(`/msls/Carrier/Add`, body);
    };
    /**
    * 详情
    */
    export var GetDetail = (id:string): Promise<type.CarrierDetailVM> => {
        return Get(`/msls/Carrier/GetDetail/${id}`, {});
    };
    /**
     * 编辑
     */
    export var Edit = (id: string, body: type.AddCarrierVM): Promise<any> => {
        return Put(`/msls/Carrier/Update/${id}`, body);
    };
    /**
    * 启用/禁用
    */
    export var Enable = (query: any): Promise<any> => {
        return Get(`/msls/Carrier/Enable?${qs.stringify(query)}`, {});
    };
    /**
     * 删除
     */
    export var DoDelete = (id: any): Promise<any> => {
        return Delete(`/msls/Carrier/Delete/${id}`, {});
    };
    

}
